import { toRefs, shallowReactive, Component } from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { addOverflow, removeOverflow } from '@/utils/body-overflow';

interface Modal {
  instance: Component;
  id: string;
  props: object;
  events: object;
}

const resetState = () => ({ instance: null, props: {}, events: {} });
const state: { modals: Modal[] } = shallowReactive({
  modal: resetState(),
  modals: [],
});

const open = (instance: Component, props: object = {}, events: object = {}) => {
  const modal = {
    id: uuidv4(),
    instance,
    props: props || {},
    events: events || {},
  };

  state.modals = [...state.modals, modal];
  removeOverflow();
  return modal;
};

const close = () => {
  state.modals = state.modals.slice(0, -1);
  if (!state.modals.length) {
    addOverflow();
  }
};

export default () => ({
  ...toRefs(state),
  open,
  close,
});
